import React from "react"
import moment from 'moment'

import "./Chatbot.css"
import Chats from "./Chats"
import ReactDOM from 'react-dom'

const modalRoot = document.body;

class Chatbot extends React.Component {


	state = {
      scrollPosList: null,
      nextScrollPos: null,
      lastScrollPos: null,
      smallDevice: false,
      focusChannel: true
  }

	constructor(props) {
		super(props)
		this.el = document.createElement('div');
	}

  componentDidUpdate() {
    this.updateScrollPosList()
  }

  componentDidMount() {
		modalRoot.appendChild(this.el);

    // resize event listener for smartphone view
    this.updateDimensions()
    window.addEventListener('resize', this.updateDimensions);

		const arr = modalRoot.className.split(" ");
		if (arr.indexOf('modal-open') === -1) {
			modalRoot.className += ' modal-open';
		}

    this.updateScrollPosList()
  }

  componentWillUnmount() {
    window.removeEventListener('resize', this.updateDimensions);
		modalRoot.removeChild(this.el);
		const arr = modalRoot.className.split(" ");
		modalRoot.className = arr.filter(s => s !== 'modal-open').join(' ');
  }

  updateScrollPosList() {
    // initialize list to save scroll positions or create new list if messages have been deleted
    if(this.props.data && (!this.state.scrollPosList || this.props.data.length < this.state.scrollPosList.length)) {
      const scrollPosList = Array(this.props.data.length).fill(null)
      this.setState({scrollPosList: scrollPosList})
    }
    // update scroll position list
    else if(this.props.data && this.state.scrollPosList && this.props.data.length > this.state.scrollPosList.length) {
      let scrollPosList = this.state.scrollPosList
      for(let i = this.state.scrollPosList.length; i < this.props.data.length; i++) {
        scrollPosList.unshift(null)
      }
      this.setState({scrollPosList: scrollPosList})
    }
  }

  updateDimensions = () => {
    if(window.innerWidth < 500 && !this.state.smallDevice) {
      this.setState({smallDevice: true})
      this.setState({focusChannel: true})
    } else if(window.innerWidth >= 500 && this.state.smallDevice){
      this.setState({smallDevice: false})
    }
  }

  // use arrow function to get parameter from onCLick function
  toggleChannel = clickedChannelId => e => {
    // if clicked channel is not the same as the active channel
    if(!this.props.activeChannelId || this.props.activeChannelId !== clickedChannelId) {
      // get channel data from backend
      this.props.initChannel(clickedChannelId)
      // put last scroll position into scroll position list if there is a scroll positon
      if(this.props.activeChannelId && this.state.scrollPosList) {
        // get last scroll positon
        let lastScrollPos = document.getElementById("chatContainer").scrollTop
        // smartphone view: get the scroll position from last focus change
        if(this.state.smallDevice) {
          lastScrollPos = this.state.lastScrollPos
        }
        // update scroll position list
        this.setState(state => {
          const scrollPosList = state.scrollPosList.map((value, index) => {
            if (this.props.data[index].id === this.props.activeChannelId) {
              return lastScrollPos
            } else {
              return value
            }
          })
          return {
            scrollPosList
          }
        })
      }

      // update active channel
      this.props.setActiveChannelId(clickedChannelId)

      // update smartphone view focus if smartphone view
      if(this.state.smallDevice) {
        this.setState({focusChannel: !this.state.focusChannel})
      }

      // update next scroll position
      if(Array.isArray(this.state.scrollPosList)) {
        for (const[index, scrollPos] of this.state.scrollPosList.entries()) {
          if(this.props.data[index].id === clickedChannelId) {
            this.setState({nextScrollPos: scrollPos})
          }
        }
      }
    }
    // else if clicked channel is the same as the active channel
    else if(this.state.smallDevice){
      this.setState({nextScrollPos: this.state.lastScrollPos})
      this.setState({focusChannel: !this.state.focusChannel})
    }
  }


  // toggle smartphone view focus and save scroll position
  toggleFocus = () => {
    this.setState({focusChannel: !this.state.focusChannel})
    this.setState({lastScrollPos: document.getElementById("chatContainer").scrollTop})
  }

  render() {
    // set classnames
    let chatbot = "chatbot"
    let channelHeaderContainer = "channel-header-container"
    let chatHeaderContainer = "chat-header-container"
    let channelContainer = "channel-container"
    let chatContainer = "chat-container hide-scrollbar"

    // define smartphone views
    if(this.state.smallDevice) {
      if(this.state.focusChannel) {
        chatbot += " chatbot-focus-channel"
        chatHeaderContainer += " hide"
        chatContainer += " hide"
      } else {
        chatbot += " chatbot-focus-chat"
        channelHeaderContainer += " hide"
        channelContainer += " hide"
        chatContainer = "chat-container"
      }
    }

    // set channel index
    let channelIndex = null
    if(Array.isArray(this.props.data) && this.props.data.length) {
      this.props.data.forEach((channel, index) => {
        if(channel && channel.id === this.props.loadedChannelId) {
          channelIndex = index
        }
      })
    }

    return  ReactDOM.createPortal(
      <div style={{position:'absolute', top:'1%', left:'1%', width:'98%', height:'98%'}}>
        <div className={chatbot}>
          <div className={channelHeaderContainer}>
            <div className="channel-header">
              Chatbot
            </div>
          </div>
          <div className={chatHeaderContainer}>
            <Chatheader toggleChatbot={this.props.toggleChatbot} toggleFocus={this.toggleFocus} smallDevice={this.state.smallDevice}/>
          </div>
          <div className={channelContainer}>
            <Channels channels={this.props.data} toggleChannel={this.toggleChannel} activeChannelId={this.props.activeChannelId} loadedChannelId={this.props.loadedChannelId} smallDevice={this.state.smallDevice}/>
          </div>
          <div className={chatContainer} id="chatContainer">
            {this.props.loadedChannelId === this.props.activeChannelId &&
              <Chats activeChannel={channelIndex !== null ? this.props.data[channelIndex] : null} scrollPos={this.state.nextScrollPos} selectOption={this.props.selectOption} repeatDialog={this.props.repeatDialog} channelIndex={channelIndex} smallDevice={this.state.smallDevice} unmountChat={this.props.unmountChat}/>
            }
          </div>
        </div>
      </div>
    , this.el)
  }
}

const Chatheader = props => (
  <div className="chat-header">
    <div className="chat-header-button-container">
      {props.smallDevice ?
        <button className="chat-header-button" onClick={props.toggleFocus}>
          {"<"}
        </button>
      : null}
    </div>
    <div className="chat-header-title">
    </div>
    <div className="chat-header-button-container">
      <button className="chat-header-button" onClick={props.toggleChatbot}>
        Exit
      </button>
    </div>
  </div>
)

/*
    <div className="chat-header-button-container">
      <button className="chat-header-button">
        Help
      </button>
    </div>

*/

function Channels (props) {
  const channels = props.channels
  if(channels && Array.isArray(channels) && channels.length) {
    let channelList = []
    channels.forEach((channel, index) => {
      // check if channel is valid
      if(channel && channel.id && Number.isInteger(channel.id) && channel.public_name && (typeof channel.public_name === 'string') && channel.icon && (typeof channel.unread === "boolean") && channel.messages && Array.isArray(channel.messages) && channel.messages.length && (typeof channel.farewell === "boolean")) {
          channelList.push(
            <li key={channel.id}>
              <Channelitem channel={channel} toggleChannel={props.toggleChannel} activeChannelId={props.activeChannelId} loadedChannelId={props.loadedChannelId} smallDevice={props.smallDevice} />
            </li>
          )
      } else {
        console.log("warning: incomplete channel index " +index +" is not displayed")
      }
    })
    return (
      <ul className="channel-list">
        {channelList}
      </ul>
    )
  }
  return null
}

function Channelitem (props) {
  // mark finished conversations
  let channelItemHeadline = "channel-item-headline"
  let channelItemTime = "channel-item-time"
  let channelItemSubline = "channel-item-subline"
  let channelItemImage = "channel-item-image"
  if(props.channel.farewell) {
    channelItemHeadline += " semi-transparent"
    channelItemTime += " semi-transparent"
    channelItemSubline += " semi-transparent"
    channelItemImage += " semi-transparent"
  }

  // classnames for active state
  let channelButton = "channel-list-button"
  let itemStatus = "channel-item-status"
  if (props.loadedChannelId === props.channel.id && !props.smallDevice) {
    channelButton += " active"
    itemStatus += " active"
  }

  // check if there are messages, set variables
  let messages = props.channel.messages
  let headline = null
  let lastDialog = null
  let timestamp = null
  let subtitle = null
  if(Array.isArray(messages) && messages.length) {
    // find last message without delay
    for(let message of messages) {
      if(message) {
        if(message.age >= 0 && message.id !== "loading" && message.type !== "media") {
          lastDialog = message
        }
      }
    }

    // set headline
    if(props.channel.public_name) headline = props.channel.public_name
    if(lastDialog) {
      // set timestamp
      if(lastDialog.timestamp) {
				timestamp = lastDialog.timestamp
				// prevent future timestamps
				let now = Date.now()
				if((now-timestamp) < 0) {
					timestamp = now
				}
			}
      // set subtitle
      if(lastDialog.text) subtitle = lastDialog.text
    }
  }

  return (
    <button className={channelButton} onClick={props.toggleChannel(props.channel.id)}>
      <div className="channel-item-container">
        <div className={itemStatus} />
        <div className={channelItemImage} style={props.channel.icon ? {backgroundImage: `url("${props.channel.icon}")`} : null} />
        <div className={channelItemHeadline}>
          {headline &&
            removeHtmlTags(headline)
          }
        </div>
        <div className={channelItemTime}>
          {timestamp &&
            moment(timestamp).fromNow()
          }
        </div>
        <div className={channelItemSubline}>
          {subtitle &&
            removeHtmlTags(subtitle)
          }
        </div>
        {props.channel.unread &&
          <div className="channel-item-unread" />
        }
      </div>
    </button>
  )
}

const removeHtmlTags = string =>
  string.split(/<[^>]*>/).join("")


export default Chatbot
